import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../../config/end-points";
import useHttp from "../../../../hooks/use-http";
import { settingAction } from "../../../../store/setting-store";
import { cuteToast } from "../../../UI/cute";

const ActiveCampaign = () => {
  const [apiKeys, setApiKeys] = useState({
    ac_url: "",
    ac_key: "",
  });
  const [status, setStatus] = useState(false);

  const is_autoresponder_loaded = useSelector(
    (state) => state.settings.is_autoresponder_loaded
  );
  const autoresponder_keys = useSelector(
    (state) => state.settings.autoresponder
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (is_autoresponder_loaded) {
      // console.log(autoresponder_keys);

      const activeCampaign = autoresponder_keys.filter(
        ({ meta_key }) => meta_key === "active campaign"
      );

      if (activeCampaign.length > 0) {
        // const meta_data = JSON.parse(activeCampaign[0].meta_data);

        setApiKeys(JSON.parse(activeCampaign[0].meta_data));
        setStatus(activeCampaign[0].status === 1 ? true : false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_autoresponder_loaded]);

  const { sendRequest } = useHttp();

  const validateKey = () => {
    sendRequest(
      {
        url: endPoints.validateActiveCampaign,
        method: "POST",
        body: {
          url: apiKeys.ac_url,
          API_TOKEN: apiKeys.ac_key,
        },
      },
      (response) => {
        if (response.message === "Invalid Keys") {
          cuteToast({
            type: "error",
            message: response.message,
            timer: 5000,
            title: "Error",
          });
        } else {
          sendRequest(
            {
              url: endPoints.insertAutoresponderkeys,
              method: "POST",
              body: {
                meta_key: "active campaign",
                meta_data: apiKeys,
              },
            },
            (response) => {
              if (response.status === 200) {
                cuteToast({
                  type: "success",
                  message: response.message,
                  timer: 5000,
                  title: "success",
                });

                dispatch(
                  settingAction.setAutoresponderStatus({ status: false })
                );
              }
            }
          );
        }
      }
    );
  };

  const disconnectResponder = () => {
    sendRequest(
      {
        url: endPoints.disconnectResponder,
        method: "POST",
        body: {
          meta_key: "active campaign",
        },
      },
      (response) => {
        dispatch(settingAction.setAutoresponderStatus({ status: false }));
      }
    );
  };
  return (
    <div className="row mt-3">
      {!status && (
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-sm-2">APP URL :</label>
            <div className="col-sm-12">
              <input
                type="email"
                className="form-control"
                placeholder="Enter ActiveCampaign App Url"
                value={apiKeys.ac_url}
                onChange={(e) =>
                  setApiKeys({ ...apiKeys, ac_url: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <label className="control-label col-sm-2">API KEY :</label>
            <div className="col-sm-12">
              <input
                type="email"
                className="form-control"
                placeholder="Enter Active campaign Api Key"
                value={apiKeys.ac_key}
                onChange={(e) =>
                  setApiKeys({ ...apiKeys, ac_key: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <button className="btn" onClick={validateKey}>
              Connect
            </button>
          </div>
        </div>
      )}

      {status && (
        <div className="form-group">
          <button className="btn" onClick={disconnectResponder}>
            Disconnect
          </button>
        </div>
      )}
    </div>
  );
};

export default ActiveCampaign;
